import { events } from '@estee/elc-service-bus';
import { Event } from '~entities/Event';
import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';

export class AppointmentReviewPaginationUseCase {
    private optionSelection: string;
    private eventRepository: EventRepository;

    constructor(optionSelection: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.optionSelection = optionSelection;
    }

    public async execute() {
        const appointmentReviewViewPayload = {
            event_name: 'read_write_review',
            event_category: 'review_pagination',
            event_action: 'pagination',
            event_label: this.optionSelection
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_REVIEW_PAGINATION,
            type: 'link',
            payload: appointmentReviewViewPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    }
}
